import React from 'react';
import './about.scss'
import Navbar from '../../components/navbar/Navbar';
import Bottombar from '../../components/bottombar/Bottombar';
import { AboutGallery } from '../../galleryImg.js'
import SocialHub from '../../components/socialHub/SocialHub';

const About = () => {
    const currentYear = new Date().getFullYear()
    const experience = currentYear - 2018

    return (
        <div className="page">

            <div className="top">
                <Navbar />
            </div>

            <div className="mainContainer">
                <div className="content">

                    <div className="contentProfile">
                        <div className="profilePic">
                            <img className="profileImg" src={AboutGallery[0].imgHigh} alt="" />
                        </div>
                        <div className="profileDesc">
                            <h1>Hello!</h1>
                            <br />
                            <p>I am a Visual Development Artist, Character Design and Illustrator with more than {experience} years of experience.</p>
                            <p>I am currently working in the animation industry as a Visual Development Artist at Ánima Kitchent.</p>
                            <p>I love telling stories through compelling designs, light and color tailored for both young and adult audiences.</p>
                            <p>I am always open to new opportunities that will not only challenge my skills but also develop new ones.</p>
                            <br />
                            <p>For freelance work or any inquiries feel free to contact me:</p>

                            <SocialHub alignment="left" />

                        </div>
                    </div>

                </div>

                <div className="bottom">
                    <Bottombar />
                </div>

            </div>
        </div>
    );
};

export default About